import { FinnairLocation } from '../api/models';

export type Quotas = Record<string, number | null>;

export type LocationInfoMap = Record<string, FinnairLocation>;

export enum BoundType {
  outbound = 'outbound',
  inbound = 'inbound',
  multi = 'multi',
}

export interface CheapestBoundPrice {
  boundId: string;
  cheapestPrice: string;
}
